import {Injectable} from '@angular/core';
import {ConstantsService} from '../../../../services/constants.service';
import {Company, Property, Theme} from '../../../../types/admin-data.types';
import {ApiClientService} from '../../../../services/api-client.service';
import {UrlService} from '../../../../services/url.service';
import {EmptyRowService} from '../../../../services/empty-row.service';
import {Observable} from 'rxjs/Observable';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import {AccountPermissionsService} from '../../../../services/account-permissions.service';
import {DateTransformer} from '../../../../services/date-transformer.service';
import {Router} from '@angular/router';
import {CondomanagerApiService} from '../../../../services/api/condomanager-api.service';
import {ICondoManagerBuildingFolder} from '../../../../types/api-response/condomanager/building-folder';
import {BuildingApiService} from '../../../../services/api/building-api.service';
import {catchError, filter, flatMap, map, startWith, take, tap, toArray} from 'rxjs/operators';
import {IBuilding} from '../../../../types/api-response/building';
import {createInitialNetworkEntity, resolveNetworkEntity} from '../../../../services/helper-functions';
import {of} from 'rxjs/observable/of';
import {from} from 'rxjs/observable/from';
import {Subject} from 'rxjs/Subject';
import {IMe} from '../../../../types/api-response/auth/me';


declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class PropertyService {
    spinnerShow = false;
    showServiceUnavailable = false;
    isServiceLoading = false;
    selectedItemData: Property;
    currentWelcomeMessage: any = '';
    currentBackgroundIMG: any;
    currentTabId: any;
    data: Property[] = [];
    companies: Company[] = [];
    corporationNumberList = [];
    corporationNumberListSearchSelect = [];
    timezoneList = [];
    services: Object;
    currentServices: any;
    total: number | null = null;
    serviceName: string = 'auth';
    isWelcomeModalShow: boolean = false;
    isInvitationEmailModalShow: boolean = false;
    contactUsModalShow: boolean = false;
    isShowView: boolean = false;
    viewedItem: Property;
    isCreateNew = false;
    buildingsList = [];
    buildings$: ReplaySubject<IBuilding[]> = new ReplaySubject(1);
    isEditShow = false;
    selectedBuildings: any = [];
    currentCorporationNumber: any;
    buildingFolders: ICondoManagerBuildingFolder[] = [];
    propertyData = {
        property: {
            get: '/v1/buildings.json?expand=contacts,corporationNumber,timeZone',
            post: '/v1/buildings.json?',
            patch: '/v1/buildings/',
            remove: '/v1/buildings/',
            data: [],
            total: null
        },
        propertyGroup: {
            get: '/v1/corporation_number.json?',
            post: '/v1/corporation_number.json?',
            patch: '/v1/corporation_number/',
            remove: '/v1/corporation_number/',
            data: [],
            total: null
        }
    };
    subscriber = null;
    selectedBuilding = null;


    public customThemes$ = new ReplaySubject<Theme[]>(1);
    customThemeModalShow: boolean = false;


    constructor(public router: Router,
                public api: ApiClientService,
                private buildingApi: BuildingApiService,
                public urlService: UrlService,
                public emptyRowService: EmptyRowService,
                public account: AccountPermissionsService,
                private condomanagerApiService: CondomanagerApiService
    ) {
    }

    get(checkedId?: number) {
        this.getByQueryParams(checkedId).subscribe();
    }

    getByQueryParams(checkedId?): Observable<any> {
        this.showServiceUnavailable = false;
        const queryParams = this.urlService.getQueryParamsString();
        const tabId = this.urlService.queryParams['tab'];
        const url = this.propertyData[tabId].get;
        let fullURL = `${url}${queryParams}`;
        if (this.propertyData[tabId] == 'property') {
            fullURL += `&expand=contacts`;
        }
        return this.api.getJson('domainBD', `${fullURL}`)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity(i => {
                    return this.account.addPermissionsToEntity(new Property(i, checkedId === +i.id), this.serviceName);
                }),
                tap(() => this.spinnerShow = true),
                filter(({finished}) => finished),
                flatMap(tabGetResponse => {
                    return this.getCompanies()
                        .pipe(
                            filter(({finished}) => finished),
                            map(
                                (companiesResponse) => {
                                    if (tabId === 'property') {
                                        tabGetResponse.entities = tabGetResponse.entities.map((i: Property) => {
                                            const assignedCompany = companiesResponse.idMap.get(i.companyId);
                                            i.companyName = assignedCompany && assignedCompany.name;
                                            return i;
                                        });
                                    }
                                    return tabGetResponse;
                                }
                            ),
                            catchError(() => of(tabGetResponse))
                        );
                }),
                tap(() => this.spinnerShow = false),
                tap((response) => {
                    this.data = response.entities;
                    this.total = response.total;
                    this.emptyRowService.fillEmptyRow();
                    this.spinnerShow = false;
                }),
                tap(
                    () => {
                        if ($('.table')[0])
                            $('.table')[0].scrollIntoView();
                    },
                    error => {
                        this.showServiceUnavailable = true;
                        this.spinnerShow = false;
                        this.api.errorHandler(error, 'Failed get Properties');
                    }
                )
            );
    }

    getCurrentServices(buildingId: number) {
        this.isServiceLoading = true;
        const queryParams = `buildingId=${buildingId}`;
        const url = `/api/v1/building_service.json?${queryParams}`;
        this.api.get('oauthUrl', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                this.currentServices = body.entities[0];
                this.isServiceLoading = false;
            },
            error => this.api.errorHandler(error, 'Failed get Building Services')
        );
    }

    getBuildingInfo() {
        const url = `/v1/buildings/${this.selectedItemData.id}.json`;
        this.api.get('domainBD', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                this.currentWelcomeMessage = body.welcomeMessage;
                this.currentBackgroundIMG = body.backgroundImage;
                this.selectedBuilding = body;
            },
            error => this.api.errorHandler(error, 'Failed get Building info')
        );
    }

    updateBuildingInfo(data: any) {
        this.isServiceLoading = true;

        return this.api.patch('domainBD', `/v1/buildings/${this.selectedItemData.id}.json`, data).map((res) => {
            toastr.success('Building info has been updated.');
            this.currentWelcomeMessage = res.welcomeMessage;
            this.currentBackgroundIMG = res.backgroundImage;
            this.selectedBuilding = res;
            this.isServiceLoading = false;
            return res;
        }, (error) => {
            this.api.errorHandler(error, 'Edit Building info failed.');
        });
    }

    getCompanies() {
        const url = `/api/v1/company.json?order-by=name|asc&expand=offices.members&per-page=1000`;
        const idMap = new Map();
        return this.api.getJson('oauthUrl', url)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity<any, Company>(
                    (item): Company => {
                        if (this.urlService.queryParams['company_id']
                            && this.router.parseUrl(this.router.url).queryParams['company_id']
                            && this.router.parseUrl(this.router.url).queryParams['company_id'].indexOf((item.id).toString()) != -1)
                            item.filtered = true;
                        const company = new Company(item);
                        idMap.set(company.id, company);
                        return company;
                    }
                ),
                map(response => {
                    return {
                        ...response,
                        idMap
                    };
                }),
                tap(
                    response => {
                        this.companies = response.entities;
                    },
                    error => this.api.errorHandler(error, 'Failed get Companies')
                )
            );
    }

    getCorporationNumberList() {
        this.corporationNumberList = [];
        const url = `/v1/corporation_number`;
        this.api.getInfiniteList('domainBD', url, 250).subscribe(
            res => {
                this.corporationNumberList = [];
                this.corporationNumberList = res.entities;
                this.corporationNumberListSearchSelect = this.corporationNumberList.map(suite => ({
                    value: suite.id,
                    optionText: suite.name
                }));
            }
        );
    }

    getCorporationNumberForSelect(searchTerm: string): Observable<{entities: {value: any, optionText: string}[], total: number}> {
        let total = undefined;
        return this.buildingApi.getCorporationNumberChunks({
            'per-page': 10,
            page: 1,
            query: `*${searchTerm}*`
        })
            .pipe(
                startWith({entities: [], total}),
                tap(({total: realTotal}) => total = realTotal),
                flatMap(response => from(response.entities)),
                map(corporationNumber => {
                    return {
                        value: corporationNumber.id,
                        optionText: corporationNumber.name
                    };
                }),
                toArray(),
                map(entities => ({
                    entities,
                    total
                }))
            );
    }

    getTimezoneList() {
        this.timezoneList = [];
        const url = `/v1/timezone?per-page=10000`;
        this.api.get('domainBD', url).subscribe(res => {
            const body = JSON.parse(res._body);
            this.timezoneList = body.entities;
        });
    }

    updateCurrentServices(data: any) {
        this.isServiceLoading = true;
        return this.api.patch('oauthUrl', `/api/v1/building_service/${this.currentServices.id}.json`, data).map((res) => {
            toastr.success('Building Services has been updated.');
            this.isServiceLoading = false;
            this.account.init();
            return res;
        }, (error) => {
            this.isServiceLoading = false;
            this.api.errorHandler(error, 'Edit Building Services failed.');
        });
    }

    createCurrentServices(data: any) {
        this.isServiceLoading = true;
        return this.api.post('oauthUrl', `/api/v1/building_service.json`, data).map((res) => {
            toastr.success('Building Services has been created.');
            this.isServiceLoading = false;
            return res;
        }, (error) => {
            this.isServiceLoading = false;
            this.api.errorHandler(error, 'Create Building Services failed.');
        });
    }

    getServices() {
        const url = `/api/v1/services_and_types.json`;
        this.api.get('oauthUrl', url).subscribe(
            res => this.services = JSON.parse(res._body),
            error => this.api.errorHandler(error, 'Failed get Services')
        );
    }

    getListCustomThemes() {
        this.api.getInfiniteList('oauthUrl', '/api/v1/custom_theme.json')
            .pipe(map(response => {
                return response.entities.map(i => {
                    return new Theme(+i.id, i.name, i.logo, i.settings, [], i.createdAt, i.createdBy, i.buildingId, i.corporationNumberId, i.company)
                })
            })).subscribe(
            res => { this.customThemes$.next(res); },
            error => this.api.errorHandler(error, 'Failed Get Custom Themes')
        )
    }

    removeCustomTheme(id): Observable<any> {
        return this.api.remove('oauthUrl', `/api/v1/custom_theme/${id}`);
    }

    createCustomTheme(theme: Partial<Theme>): Observable<Theme> {
        return this.api.post('oauthUrl', '/api/v1/custom_theme.json', theme).pipe(
            map((i) => new Theme(+i.id, i.name, i.logo, i.settings, [], i.createdAt, i.createdBy, i.buildingId, i.corporationNumberId, i.company))
        );
    }

    updateCustomTheme(id, theme: Partial<Theme>): Observable<Theme> {
        return this.api.patch('oauthUrl', `/api/v1/custom_theme/${id}`, theme).pipe(
            map((i) => new Theme(+i.id, i.name, i.logo, i.settings, [], i.createdAt, i.createdBy, i.buildingId, i.corporationNumberId, i.company))
        );
    }

    getBuildings() {
        this.buildingsList = [];

        this.buildingApi.getBuildings({'per-page': 1500, 'order-by': 'name|asc'}, true)
            .pipe(take(1)).subscribe(buildings => {
            this.buildingsList = buildings.entities;
            this.buildings$.next(buildings.entities);
        });
    }

    getBuildingFolders() {
        this.buildingFolders = [];
        this.condomanagerApiService.getBuildingFolders().subscribe(res => {
            this.buildingFolders = res.entities;
        });
    }

    create(data) {
        const tabId = this.urlService.queryParams['tab'];
        const url = this.propertyData[tabId].post;
        return this.api.post('domainBD', `${url}`, data).map((res) => {
            return res;
        }, (error) => {
            this.api.errorHandler(error, 'Create property failed.');
            return error;
        });
    }

    update(id: number, data: any) {
        this.spinnerShow = true;
        const tabId = this.urlService.queryParams['tab'];
        const urlUpdate = this.propertyData[tabId].patch;
        return this.api.patch('domainBD', `${urlUpdate}${id}.json`, data).map((res) => {
            toastr.success('Property has been updated.');
            this.spinnerShow = false;
            return res;
        }, (error) => {
            this.spinnerShow = false;
            this.api.errorHandler(error, 'Edit property failed.');
        });
    }

    remove(id: number): Observable<any> {
        if (!id) return;
        const tabId = this.urlService.queryParams['tab'];
        const urlDelete = this.propertyData[tabId].remove;
        const subject = new ReplaySubject<any>(null);

        swal(ConstantsService.getSwalConfig(`Delete ${tabId == 'property' ? 'Property' : 'Corporation'}?`),
            () => {
                const url = `${urlDelete}${id}.json`;
                this.api.remove('domainBD', url).subscribe(
                    (res) => {
                        toastr.success('Property item has been deleted.');
                        if (this.data.length - 1 == 0 && this.urlService.queryParams.page != '1')
                            this.urlService.queryParams.page = (parseInt(this.urlService.queryParams.page) - 1).toString();
                        this.get();
                        subject.next(res);
                    },
                    error => this.api.errorHandler(error, 'Delete property failed')
                );
            }
        );

        return subject;
    }

    toggleCheck(item: Property): boolean {
        const checked = item.checked;
        this.data.forEach(i => i.checked = false);
        if (!checked) {
            item.checked = true;
        }
        this.selectedItemData = JSON.parse(JSON.stringify(item));

        return item.checked;
    }

    transformDate(date: Date): string {
        return DateTransformer.transformDate(date);
    }

    canEdit(buildingId?: number) {
        return this.account.canUpdate(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {
        return this.account.canDelete(this.serviceName, buildingId);
    }

    userIsSuperAdmin() {
        const userType = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).userType : '';
        return userType == 'super_admin';
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/services/property.service.ts